// extracted by mini-css-extract-plugin
export default {"noResultForFilter":"NoResultForFilter-module__noResultForFilter_bVgeB","text":"NoResultForFilter-module__text_HsoC9"};